export default __webpack_public_path__ + "7032f89395f4a2c2cd5820348029bd4f.svg";